import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseHoldReasonsAdapter = getAdapter({ idFieldName: 'value' });

const warehouseHoldReasonsSlice = createSlice({
  name: 'warehouseHoldReasons',
  initialState: warehouseHoldReasonsAdapter.getInitialState(),
  reducers: {
    setWarehouseHoldReasons: (state, { payload: { holdReasons } }) => {
      warehouseHoldReasonsAdapter.setAll(state, holdReasons);
    },
  },
});

const selectors = warehouseHoldReasonsAdapter.getSelectors(({ warehouseHoldReasons }) => warehouseHoldReasons);

export const getWarehouseHoldReasonsIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseHoldReasons = (state) => getWarehouseHoldReasonsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseHoldReasons,
} = warehouseHoldReasonsSlice.actions;

export default warehouseHoldReasonsSlice.reducer;
